/**
 * PuraGems Collection Filter Bar v2
 * — Scroll arrows for all category rows
 * — Filter button click handler (Stone, Metal — Shopify native filters)
 * — Link-based items (Style, Shape) navigate via native <a> tags
 */

if (!customElements.get('pg-filter-bar')) {
  class PgFilterBar extends HTMLElement {
    constructor() {
      super();
      this.scrollAmount = 180;
    }

    connectedCallback() {
      this.initScrollArrows();
      this.initFilterButtons();
    }

    /* ── Scroll arrows for all category rows ── */
    initScrollArrows() {
      this.querySelectorAll('.pg-filter-category__arrow').forEach((arrow) => {
        arrow.addEventListener('click', (e) => {
          e.preventDefault();
          const category = arrow.closest('.pg-filter-category');
          const scroller = category.querySelector('.pg-filter-category__items');
          if (!scroller) return;

          const direction = arrow.dataset.direction;
          const scrollLeft = direction === 'right'
            ? scroller.scrollLeft + this.scrollAmount
            : scroller.scrollLeft - this.scrollAmount;

          scroller.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        });
      });
    }

    /* ── Filter buttons (Stone, Metal) — toggle Shopify facet checkboxes ── */
    initFilterButtons() {
      this.querySelectorAll('button.pg-filter-option[data-filter-input]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const inputId = btn.dataset.filterInput;
          const facetInput = document.getElementById(inputId);
          if (facetInput) {
            facetInput.checked = !facetInput.checked;
            facetInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
  }

  customElements.define('pg-filter-bar', PgFilterBar);
}
